import React,{useState,useEffect} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Fab from '@material-ui/core/Fab';
import PrintIcon from '@material-ui/icons/Print';
import FormLabel from '@material-ui/core/FormLabel';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import Paper from '@material-ui/core/Paper';
import WelcomeCard from './welcome-card'
import RankCard from './rank-card'
import ScholarshipCard from './scholarship-card'
import ScoreCard from './score-card'
import CashPrizeCard from './cash-prize-card'
import {http_request} from '../../../../../../../../utils/http_request'
import {endpoint} from '../../../../../../../../config'
import ErrorLoadingText from '../../../../../../../../utils/error-loading-text'
import Typography from '@material-ui/core/Typography';
import YourScoreVsAvgScore from './your-score-vs-avg-score'
import TopicwiseAnalysis from './topic-wise-analysis'
export default function SpacingGrid() {
  const [loader, toggleLoader] = useState(true);

const[error,setError]=useState(null)
  const[data,setData]=useState(null)
    useEffect(() => {

      async function fetchData() {
        try{
           const data=  await http_request({endpoint:endpoint,service:'aptitude-test-data-1-new',variables:`auth_token=${localStorage.getItem("aptitude_test_token")}`});

   setData(data.data)
         }
         catch(e){
  setError(e)
         }
         finally{
           toggleLoader(false)
         }
       }

             fetchData();
         },[]
      );


if(loader)
return <ErrorLoadingText>Loading...</ErrorLoadingText>
 if(error)
 return <ErrorLoadingText>{error.message}</ErrorLoadingText>

 let {result}=data
 let is_show_bio_ma=false;
 const classs=result['classs'];console.log(result);
  const sql_test_date=result['sql_test_date'];
 if(classs==='06th' || classs==='07th' || classs==='08th' || classs==='09th' || classs==='10th') 
	is_show_bio_ma=true;
 
if(classs==='11th' && (sql_test_date==='2021-01-03' || sql_test_date==='2021-03-28') )
		is_show_bio_ma=true;

	
 
  return (
    <>
{/*    <Fab onClick={()=>window.print()} color="primary" aria-label="add" style={{position:'fixed',bottom:5,right:5}}>
            <PrintIcon />
          </Fab>*/}
    <Grid container  spacing={2}  >

      <Grid item xs={12} sm={6} md={4}>
          <WelcomeCard roll_no={result.roll_no} name={result.name} classs={result.classs} test_date={result.test_date}/>

      </Grid>

      <Grid item xs={12} sm={6} md={2}>
      <RankCard  rank={result.rank}/>
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
      {
        result.scholarship!=0 && <ScholarshipCard scholarship={result.scholarship}/>

    }
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
      {
        result.cash_prize!='NA' && <CashPrizeCard cash_prize={result.cash_prize}/>

    }
      </Grid>
 <div className="pagebreak"></div>
      <Grid item xs={12}>

            <ScoreCard {...result} is_show_bio_ma={is_show_bio_ma}/>
      </Grid>

      <Grid item xs={12}>

            <YourScoreVsAvgScore {...result} is_show_bio_ma={is_show_bio_ma}/>
      </Grid>
      <Grid item xs={12}>

            <TopicwiseAnalysis {...result} is_show_bio_ma={is_show_bio_ma}/>
      </Grid>

    </Grid>




    <div className="screen_only">


    <br /><br />
    <center>
 <Button style={{width:240}} variant="contained" color="primary" href="https://www.reliablekota.com/apps2122/AppForms/Register" target="_blank">Apply Now </Button> <br /> <Typography>for Year long Classroom programs (Offline/Online)</Typography>
  </center>
<br /><br />
 {/*
    <Typography variant="h5">
     Upcoming Courses
   </Typography>  <br /><br />
  
    <Grid item container xs={12}>





   <Grid item xs={12} md={4}>
   <br />
     <a href="https://www.reliablekota.com/Online-R-NET.aspx" target="_blank">
<img style={{width:300 }} src="https://reliablekota.com/images/slider/rnet-300px-advertisement.png"/>
</a>
    </Grid>
    <Grid item xs={12} md={4}>
    <br />
	 <a href="https://www.reliablekota.com/iit-jee-main-advanced-coaching/courses-for-jee-main-advanced-2020-21.aspx" target="_blank">
 <img style={{width:300 }} src="https://reliablekota.com/images/slider/vikaas-300px-advertisement.png"/>
 </a>
     </Grid>
     <Grid item xs={12} md={4}>
     <br />
   <a href="https://www.reliablekota.com/iit-jee-main-advanced-coaching/courses-for-jee-main-advanced-2020-21.aspx#lvyapak" target="_blank">
 <img style={{width:300 }} src="https://reliablekota.com/images/slider/vyapak-300px-advertisement.png"/>
 </a>
      </Grid>
      <Grid item xs={12} md={4}>
<br />
   
    <a href="https://www.reliablekota.com/junior-division/class-6-to-10-classroom-courses-2020-21.aspx" target="_blank">
 <img style={{width:300 }} src="https://reliablekota.com/images/slider/advance-batch-300px-advertisement.png"/>
 </a>
       </Grid>
	   <Grid item xs={12} md={4}>
<br />
   
    <a href="https://www.reliablekota.com/workshop/school-enrichment-workshop-jan-2021.aspx" target="_blank">
 <img style={{width:300 }} src="https://reliablekota.com/images/slider/school-enrichment-300px-advertisement.png"/>
 </a>
       </Grid>
 </Grid>
*/}

    </div>



    <footer  style={{backgroundColor:'#eee',margin:10,padding:10}}>

         <Typography variant="body1">
For any further assistance. Please call <a href="tel:+91-744-2665544">+91-744-2665544</a>
         </Typography>


     </footer>

    </>
  );
}
